import React, { useState, useEffect, createContext, useContext } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';

//TODO: Typing

const MediaQueryContext = createContext<any>({});

export default function MediaQueryContextProvider({ children }) {
  const matchExtraSmall = useMediaQuery('(max-width:600px)');
  const matchSmall = useMediaQuery('(min-width:600px) and (max-width:960px)');
  const matchMedium = useMediaQuery('(min-width:960px) and (max-width:1280px)');
  const matchLarge = useMediaQuery('(min-width:1280px) and (max-width:1920px)');
  const matchExtraLarge = useMediaQuery('(min-width:1921px)');
  const [isXS, setIsXS] = useState<boolean>(false);
  const [isS, setIsS] = useState<boolean>(false);
  const [isM, setIsM] = useState<boolean>(false);
  const [isL, setIsL] = useState<boolean>(false);
  const [isXL, setIsXL] = useState<boolean>(false);

  useEffect(() => {
    setIsXS(matchExtraSmall);
  }, [matchExtraSmall]);

  useEffect(() => {
    setIsS(matchSmall);
  }, [matchSmall]);

  useEffect(() => {
    setIsM(matchMedium);
  }, [matchMedium]);

  useEffect(() => {
    setIsL(matchLarge);
  }, [matchLarge]);

  useEffect(() => {
    setIsXL(matchExtraLarge);
  }, [matchExtraLarge]);

  return <MediaQueryContext.Provider value={{ isXS, isS, isM, isL, isXL }}>{children}</MediaQueryContext.Provider>;
}

export function useMQ() {
  const context = useContext(MediaQueryContext);
  return context;
}
